export const GET_SYSTEM = 'GET_SYSTEM'
export const CHANGED_SYSTEM_VALUE = 'CHANGED_SYSTEM_VALUE'
